<template>
  <div
    class="product-vignette__delivery-format"
    v-if="screenSize != 'mobile' && (isEboxDelivery || isFreeShipping)"
    :data-testid="`${testId}-vignette_deliveryFormat`"
  >
    <div class="product-vignette__description-item">
      <span
        class="product-vignette__description-icon si"
        :data-testid="`${testId}-vignette_deliveryFormat_icon`"
        :class="{
          'si-email': isEboxDelivery,
          'si-free-delivery': isFreeShipping,
        }"
      >
      </span>
      <span>{{ isFreeShipping ? $t('deliveryFormat_freeShipping') : $t(dynamicBrandTranslation('deliveryFormat_eBox')) }}</span>
    </div>
  </div>
</template>

<script lang="js">
import { dynamicBrandTranslation } from '../../../utils/brandingUtils.js';

export default {
  name: 'deliveryFormat',
  props: {
    isFreeShipping: Boolean,
    isEboxDelivery: Boolean,
    testId: String,
    screenSize: String,
  },
  methods: {
    dynamicBrandTranslation,
  },
};
</script>
<style lang="scss" scoped>
@import '../../../scss/variables';
@import '../../../scss/smartbox-icons';

$old-price: #595959;

.product-vignette__description-item {
  display: flex;
  flex-direction: row;
  list-style: none;
  margin-bottom: rem-calc(12);
  font-size: rem-calc(14);
  line-height: rem-calc(18);
  color: $old-price;

  &:last-child {
    margin-bottom: 0;
  }
}

.product-vignette__description-icon {
  color: $old-price;
  font-size: rem-calc(28);
  line-height: rem-calc(17);
  margin-right: rem-calc(4);
}

.si-free-delivery {
  font-size: 1rem;
}
</style>
